import { axiosCoreInstance } from "./api-client"

export interface Tag {
    key: string;
    value: string;
}

export interface ScheduleWorkflowPayload {
    artifact_file_path: string,
    artifact_data: string,
    mlflow_model_name: string,
    model_type: string,
    request_json: string | null,
    response_json: string | null,
    tags: Tag[],
    description: string | null
}

export const scheduleWorkflow = async (payload: ScheduleWorkflowPayload) => {
    try{
        // console.log("In the work service file ", payload);
        const response = await axiosCoreInstance.post(`schedule_workflow`, payload);
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
}